// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
const AutoLoanIndexDisbursementTypes = {
	/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
	FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_START:
		'fetch_particular_auto_loan_index_details_start',
	FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_SUCCESS:
		'fetch_particular_auto_loan_index_details_success',
	FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_FAILURE:
		'fetch_particular_auto_loan_index_details_failure',
	FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_RESPONSE_RESET:
		'fetch_particular_auto_loan_index_details_response_reset',
	FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
		'fetch_particular_auto_loan_index_details_response_changed',
	/*********** FETCH PARTICULAR LOAN INDEX END ************************ */

	/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
	HDFC_CREATE_INDIVIDUAL_QRCODE_START: 'hdfc_create_individual_qrcode_start',
	HDFC_CREATE_INDIVIDUAL_QRCODE_SUCCESS: 'hdfc_create_individual_qrcode_success',
	HDFC_CREATE_INDIVIDUAL_QRCODE_FAILURE: 'hdfc_create_individual_qrcode_failure',
	HDFC_CREATE_INDIVIDUAL_QRCODE_RESPONSE_RESET: 'hdfc_create_individual_qrcode_response_reset',
	HDFC_CREATE_INDIVIDUAL_QRCODE_RESPONSE_CHANGED:
		'hdfc_create_individual_qrcode_response_changed',
	/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

	/*********** GROUP WISE AUTO LOAN LIST START ************************ */
	GROUP_WISE_AUTO_LOAN_LIST_START: 'group_wise_auto_loan_list_start',
	GROUP_WISE_AUTO_LOAN_LIST_SUCCESS: 'group_wise_auto_loan_list_success',
	GROUP_WISE_AUTO_LOAN_LIST_FAILURE: 'group_wise_auto_loan_list_failure',
	GROUP_WISE_AUTO_LOAN_LIST_RESPONSE_RESET: 'group_wise_auto_loan_list_response_reset',
	GROUP_WISE_AUTO_LOAN_LIST_RESPONSE_CHANGED: 'group_wise_auto_loan_list_response_changed',
	/*********** GROUP WISE AUTO LOAN LIST END ************************ */

	/***************** AUTO LOAN DISBURSEMENT START *******************/
	ADD_AUTO_LOAN_INDEX_DISBURSEMENT_START: 'add_auto_loan_index_disbursement_start',
	ADD_AUTO_LOAN_INDEX_DISBURSEMENT_SUCCESS: 'add_auto_loan_index_disbursement_success',
	ADD_AUTO_LOAN_INDEX_DISBURSEMENT_FAILURE: 'add_auto_loan_index_disbursement_failure',
	ADD_AUTO_LOAN_INDEX_DISBURSEMENT_RESPONSE_RESET:
		'add_auto_loan_index_disbursement_response_reset',
	ADD_AUTO_LOAN_INDEX_DISBURSEMENT_RESPONSE_CHANGED:
		'add_auto_loan_index_disbursement_response_changed',
	/***************** AUTO LOAN DISBURSEMENT END *******************/

	/***************** AUTO LOAN INDEX SCHEDULE START *******************/
	GET_AUTO_LOAN_INDEX_SCHEDULE_START: 'get_auto_loan_index_schedule_start',
	GET_AUTO_LOAN_INDEX_SCHEDULE_SUCCESS: 'get_auto_loan_index_schedule_success',
	GET_AUTO_LOAN_INDEX_SCHEDULE_FAILURE: 'get_auto_loan_index_schedule_failure',
	GET_AUTO_LOAN_INDEX_SCHEDULE_RESPONSE_RESET: 'get_auto_loan_index_schedule_response_reset',
	GET_AUTO_LOAN_INDEX_SCHEDULE_RESPONSE_CHANGED: 'get_auto_loan_index_schedule_response_changed',
	/***************** AUTO LOAN INDEX SCHEDULE END *******************/

	/***************** DELETE PARTICULAR AUTO LOAN INDEX START *******************/
	DELETE_PARTICULAR_AUTO_LOAN_INDEX_START: 'delete_particular_auto_loan_index_start',
	DELETE_PARTICULAR_AUTO_LOAN_INDEX_SUCCESS: 'delete_particular_auto_loan_index_success',
	DELETE_PARTICULAR_AUTO_LOAN_INDEX_FAILURE: 'delete_particular_auto_loan_index_failure',
	DELETE_PARTICULAR_AUTO_LOAN_INDEX_RESPONSE_RESET:
		'delete_particular_auto_loan_index_response_reset',
	DELETE_PARTICULAR_AUTO_LOAN_INDEX_RESPONSE_CHANGED:
		'delete_particular_auto_loan_index_response_changed',
	/*****************  DELETE PARTICULAR AUTO LOAN INDEX END *******************/
};
export default AutoLoanIndexDisbursementTypes;
